export const contactsHeaderTitles = {
  title: 'Контакти',
  orderBtn: 'Замовити',
};
